module.exports = __webpack_public_path__ + "img/image22.af425fbe.jpeg";